/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Profile_PluralInputs */

const en_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`profiles`)
};

const zh_hans1_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主页`)
};

const pt_br2_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perfis`)
};

const es_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`perfiles`)
};

const fr_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`profils`)
};

const de_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const ru_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`профилей`)
};

const it_measure_unit_profile_plural = /** @type {(inputs: Measure_Unit_Profile_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`profili`)
};

/**
* | output |
* | --- |
* | "profiles" |
*
* @param {Measure_Unit_Profile_PluralInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_profile_plural = /** @type {((inputs?: Measure_Unit_Profile_PluralInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Profile_PluralInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_profile_plural(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_profile_plural(inputs)
	if (locale === "es") return es_measure_unit_profile_plural(inputs)
	if (locale === "fr") return fr_measure_unit_profile_plural(inputs)
	if (locale === "de") return de_measure_unit_profile_plural(inputs)
	if (locale === "ru") return ru_measure_unit_profile_plural(inputs)
	if (locale === "it") return it_measure_unit_profile_plural(inputs)
	return en_measure_unit_profile_plural(inputs)
});